import React, { useContext } from 'react'

import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'

import styles from './ContactContent.module.scss'

export const ContactContent = () => {
  const { t, tDanger } = useTranslation()
  const { store } = useContext(MetadataContext)

  const storeEmail = store?.config?.email

  return (
    <>
      <div className={styles.title}>
        <h1>{t('contact:CONTACT_PAGE_TITLE')}</h1>
        <p className="subtitle">{t('contact:CONTACT_PAGE_INTRO_TEXT')}</p>
      </div>

      <div
        className={styles.sendUsEmailAt}
        {...tDanger('contact:OR_SEND_US_AN_EMAIL_AT_X', {
          arg1: `<a href="mailto:${storeEmail}">${storeEmail}</a>`,
        })}
      />
    </>
  )
}
